<template>
  <section class="block-directions directions">
    <div class="container">
      <div class="directions__head">
        <h2 class="directions__title title">Направления</h2>
        <div class="swiper-pagination"></div>
        <div class="directions__controls" v-if="device_platform !== 'mobile'">
          <div class="arrow arrow-prev"></div>
          <div class="arrow arrow-next"></div>
        </div>
      </div>

      <!--        Листу нужно добавить класс slide-1, slide-2-->
      <div class="swiper-container directions-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(list, slide) of directions_list" :key="list">
            <div
              class="directions__list"
              :class="`directions__slide-${slide + 1}`"
            >
              <div
                class="dir"
                :class="'_' + dir.key"
                v-for="dir in list"
                :key="dir.key"
              >
                <!-- <img :src="require('../images/directions/' + dir.key + '.jpg')" alt=""> -->

                <div class="dir__main">
                  <div class="dir__title" :class="dir.title_color">
                    {{ dir.title }}
                  </div>

                  <button
                    class="dir__btn button button_theme_primary"
                    @click="
                      getCall({
                        type: 'sale',
                        form: 'directions',
                        title: 'Оставить заявку',
                      })
                    "
                  >
                    Оставить заявку
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Mixin from "../common/mixin";
import DIRECTIONS from "../common/directions";
import Swiper from "swiper";

export default {
  name: "block-directions",
  mixins: [Mixin],
  data() {
    return {};
  },
  computed: {
    directions_list() {
      if (this.device_platform === "mobile") {
        return DIRECTIONS;
      } else {
        return DIRECTIONS;
      }
    },
  },
  methods: {
    initSwiper() {
      if (this.swiper) return;
      this.swiper = new Swiper(`.directions-swiper`, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        simulateTouch: true,
        navigation: {
          nextEl: `.directions .arrow-next`,
          prevEl: `.directions .arrow-prev`,
        },
        pagination: {
          el: ".directions .swiper-pagination",
          type: "progressbar",
        },
        breakpoints: {
          800: {
            spaceBetween: 12,
          },
        },
      });
    },
  },
  mounted() {
    this.initSwiper();
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.directions {
  margin-top: 70px;
  &__list {
    width: 100%;
    height: calc(100vw * 880 / 1440);
    color: $white;
    display: grid;
    grid-template-rows: repeat(3, 1fr);
    gap: 8px;
  }

  &__slide-1 {
    grid-template-areas:
      "_1 _2 _2 _3"
      "_4 _4 _5 _5"
      "_4 _4 _5 _5";
    grid-template-columns: 39% 20.78% 10.39% 28.31%;
  }

  &__slide-2 {
    grid-template-areas:
      "_1 _1 _2"
      "_3 _4 _2"
      "_3 _4 _5";
    grid-template-columns: 25.3% 45.78% 28.1%;
  }

  &__slide-3 {
    grid-template-areas:
      "_1 _2 _2 _3"
      "_1 _2 _2 _3"
      "_4 _4 _5 _5";
    grid-template-columns: 32.07% 7.06% 36.7% 22.59%;
  }

  &__head {
    position: relative;
    display: flex;
    align-items: flex-end;
    margin-bottom: 40px;
  }

  &__controls {
    display: flex;
    align-items: center;
    margin-bottom: 9px;
  }

  .dir {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    overflow: hidden;

    & img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &__main {
      position: absolute;
      left: 24px;
      bottom: 16px;
      width: calc(100% - 48px);
    }

    &__title {
      font-size: 28px;
      font-family: "Bebas Neue", sans-serif;
      font-weight: 700;
      letter-spacing: 0.05em;

      &.black {
        color: $black;
      }
    }

    &__btn {
      // display: none;
      margin-bottom: -80px;
      margin-top: 21px;
      transition: all 200ms linear;
      &:hover::after {
        content: none;
      }
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.5);
      .dir__btn {
        // display: block;
        margin-bottom: 0;
        // height: 54px;
      }
    }
  }

  .swiper-pagination {
    position: unset;
    flex: 1;
    height: 2px;
    margin: 0 12px 9px;
  }

  $slides: (
    "1": 5,
    "2": 5,
    "3": 5,
  );

  @each $slide, $count in $slides {
    @for $i from 1 through $count {
      &__slide-#{$slide} {
        .dir._#{$i} {
          grid-area: _#{$i};
          background-image: url("../images/directions/#{$slide}/#{$i}.jpg");
          background-size: cover;
          background-position: center;
        }
      }
    }
  }
}

@media (max-width: 1100px) {
  .directions {
    &__list {
      height: calc((100vw - 48px) * 880 / 1336);
    }
  }
}

@media (max-width: 800px) {
  .directions {
    margin-top: 0;
    &__list {
      height: 500px;
      grid-template-areas:
        "_2 _2 _2"
        "_1 _3 _3"
        "_1 _6 _6";
      grid-template-rows: repeat(3, 32%);
      grid-template-columns: 45% 25% 25%;
      gap: 3px;
    }

    .dir {
      &__main {
        width: calc(100% - 20px);
        left: 5px;
        bottom: 20px;
      }
      &__title {
        font-size: 16px;
      }
      &__btn {
        height: 30px;
        font-size: 12px;
      }
      &._4,
      &._5 {
        display: none;
      }
    }


  }


}
</style>
